<template>
  <!--
      作者：luoyiming
      时间：2019-06-04
      描述：插件中心-优惠券-优惠券列表-修改优惠券
      -->
  <div v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <div class="common-form">基本信息</div>
      <el-form-item label="卡包类型">
       <el-radio-group v-model="form.coupon_type">
         <el-radio :label="10">满减券</el-radio>
         <el-radio :label="20">折扣券</el-radio>
      <!--    <el-radio :label="30">提货卡</el-radio>-->
         <el-radio :label="50">会员专享券</el-radio>
         <!-- <el-radio :label="60">指定商品</el-radio> -->
         <el-radio :label="70">赠送券</el-radio>
       </el-radio-group>
      </el-form-item>
      <el-form-item label="卡包名称" prop="name" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.name" placeholder="请输入卡包名称"></el-input>
        <div class="tips">例如：满100减10</div>
      </el-form-item>

      <el-form-item label="卡包背景图">
        <div v-if="form.bgImage" class="default-image-box" @click="bgUpload('bg')">
          <div class="image-box">
            <img :src="form.bgImage.file_path" alt="bgImage">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('bg')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('bg')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>推荐尺寸：显示图片长宽为 1000×600</p>
        </div>
      </el-form-item>
      <el-form-item label="分享封面">
        <div v-if="form.shareImage" class="default-image-box" @click="bgUpload('share')">
          <div class="image-box">
            <img :src="form.shareImage.file_path" alt="shareImage">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('share')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('share')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>尺寸：显示图片长宽为 500×400</p>
        </div>
      </el-form-item>
      <el-form-item label="兑换背景" v-if="form.coupon_type==30">
        <div v-if="form.exchange_bg" class="default-image-box" @click="bgUpload('exchange_bg')">
          <div class="image-box">
            <img :src="form.exchange_bg" alt="exchange_bg">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('exchange_bg')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('exchange_bg')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>建议尺寸：750*1334</p>
        </div>
      </el-form-item>
      <div  v-if="form.coupon_type==30">
        <el-form-item label="限制兑换时间">
          <el-radio-group v-model="form.exchange_type">
            <el-radio :label="0">不限制</el-radio>
            <el-radio :label="10">限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效兑换时间" v-if="form.exchange_type==10">
          <el-date-picker
            v-model="form.exchange_time"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="兑换开始时间"
            end-placeholder="兑换结束时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
          </el-form-item>
      </div>


      <!-- <el-form-item label="选择归属分销商" v-if="form.coupon_type == 30">
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择分销商</el-button>
            <ul class="d-s-s select-user"  v-if="referee">
              <li class="mr10 d-c-c d-c p-10-0" >
                  <img :src="referee.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{referee.nickName}}</p>
              </li>
              <li class="mr10 d-c-c d-c p-10-0" @click="deleteReferee">
                  删除
              </li>
            </ul>
          </div>
        </el-form-item> -->

      <el-form-item label="卡包颜色">
        <el-radio-group v-model="form.color">
          <el-radio :label="10">蓝色</el-radio>
          <el-radio :label="20">红色</el-radio>
          <el-radio :label="30">紫色</el-radio>
          <el-radio :label="40">黄色</el-radio>
           <el-radio :label="60">紫色</el-radio>
           <el-radio :label="70">黄色</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="到期类型">
        <el-radio-group v-model="form.expire_type">
          <el-radio :label="10">领取后生效</el-radio>
          <el-radio :label="20">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="Number(form.expire_type) === 10">
        <el-form-item label="有效天数">
          <el-input v-model="form.expire_day" placeholder="请输入有效天数" type="number"></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="有效时间">
          <el-date-picker v-model="form.active_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </div>

      <!-- <el-form-item label="是否开启分享优惠券">
        <el-radio-group v-model="form.is_share">
          <el-radio :label="0">不开启</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <!-- 关联商家 -->
      <div class="common-form mt50">关联设置</div>
      <el-form-item size="small" label="关联商家">
        <el-button icon="el-icon-plus" @click="openMerchantDialog">选择关联商家</el-button>
        <div class="pb50">
          <el-table size="small" :data="form.merchants" border>
            <el-table-column label="头像" width="60">
              <template slot-scope="scope">
                <div class="merchant-info">
                  <div class="pic">
                    <img width="30px" height="30px" v-img-url="scope.row.avatarUrl" alt="avatar"/>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="nickName" label="商家昵称"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="role" label="用户角色">
              <template slot-scope="scope">
                <span v-if="scope.row.role === 'supply'">供应商</span>
                <span v-else-if="scope.row.role === 'agent'">分销商</span>
                <span v-else-if="scope.row.role === 'user'">普通用户</span>
                <span v-else>{{ scope.row.role }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteMerchantClick(scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="tips">只能选择一个商家，如需更换请先删除当前商家</div>
      </el-form-item>

      <span v-if="Number(form.coupon_type)  === 40">
        <div >
        <el-form-item label="充值卡激活赠送卡余额">
          <el-input v-model="form.price" :disabled="true" placeholder="请输入充值卡激活赠送卡余额" type="number"></el-input>
          </el-form-item>
        </div>

        <div >
          <el-form-item label="充值卡激活费用">
            <el-input v-model="form.nprice" :disabled="true" placeholder="请输入充值卡激活费用" type="number"></el-input>
          </el-form-item>
        </div>
      </span>

      <!--添加门店-->
      <Pickup :form="form" v-if="Number(form.coupon_type) === 30" :type="'edit'"></Pickup>
      <Coupon :form="form" v-else-if="Number(form.coupon_type) != 40"></Coupon>

      <el-form-item label="使用说明" v-if="form.coupon_type!=40 ">
        <div class="edit_container">
          <Uediter :text="form.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>

      <!--选择商家弹窗-->
      <GetUser
        :is_open="open_merchant"
        :onlySupply="true"
        :multi="false"
        @close="closeMerchantDialogFunc">
      </GetUser>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" size="small" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--详情附加图片组件-->
    <Upload v-if="isBgUpload" :config="{ total: 9 }" :isupload="isBgUpload" @returnImgs="returnBgImgFunc">上传图片</Upload>
  </div>
</template>

<script>
import CouponApi from '@/api/coupon.js'
import {formatModel} from '@/utils/base.js'
import {mergeTable} from '@/utils/table.js'
import Coupon from "./part/Coupon"
import Pickup from "./part/Pickup"
import Upload from "@/components/file/Upload"
import Uediter from '@/components/UE.vue'
import GetUser from '@/components/user/GetUser.vue';

export default {
  components: {
    Coupon,
    Pickup,
    Upload,
    Uediter,
    GetUser
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        /*优惠券ID*/
        coupon_id:'',
        /*优惠券名称*/
        name:'',
        /*优惠券颜色*/
        color:'',
        /*优惠券类型*/
        coupon_type:'',
        /*减免金额*/
        reduce_price:'',
        /*折扣率*/
        discount:'',
        /*最低消费金额*/
        min_price:'',
        /*到期类型*/
        expire_type:'',
        exchange_type: '',
        exchange_time:'',
        /*有效天数*/
        expire_day:'',
        /*有效期*/
        active_time:'',
        is_share:0,
        /*发放量*/
        total_num:'',
        /*排序*/
        sort: 1,
        /*商家列表（只存储一个）*/
        merchants: [],
        /*商家用户ID - 对应数据库的user_id字段*/
        user_id: 0,
        product_del_ids: [],
        // 优惠券背景图
        bg_image: 0,
        bgImage: null,
        // 优惠券分享图片
        share_image: 0,
        shareImage: null,
        exchange_bg: '',
        // 优惠券使用说明
        content: '',
        // 使用次数
        usage_count: 1,
        price:0,
        nprice:0,
      },
      list: {},
      /*是否正在加载*/
      loading: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      // 背景图上传开关
      isBgUpload: false,
      bg_type:'',
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*获取商家是否显示*/
      open_merchant: false,
    };
  },
  created() {
    let coupon_id = this.$route.query.coupon_id;
    this.getData(coupon_id);
  },
  methods: {
    /*获取优惠券详情*/
    getData(coupon_id) {
      let self = this;
      CouponApi.couponDetail(
        {
          coupon_id: coupon_id
        },
        true
      )
        .then(data => {
          let obj = data.data.detail;
          console.log('优惠券详情数据：', obj);

          //选中
          obj.color = data.data.detail.color.value;
          obj.coupon_type = data.data.detail.coupon_type.value;

          // 初始化商家列表（从user对象中获取商家信息）
          self.form.merchants = [];
          if (obj.user_id && obj.user_id > 0 && obj.user) {
            // 使用返回的user对象信息
            self.form.merchants = [{
              user_id: obj.user.user_id,
              nickName: obj.user.nickName,
              avatarUrl: obj.user.avatarUrl,
              mobile: obj.user.mobile || '',
              role: 'supply' // 这里假设是供应商，如果没有role字段，可以设置为默认值
            }];
            console.log('已初始化的商家信息：', self.form.merchants[0]);
          } else {
            console.log('未关联商家或商家信息不完整');
          }

          // 使用formatModel填充form数据
          self.form = formatModel(self.form, obj);

          // 确保user_id正确设置
          self.form.user_id = obj.user_id || 0;

          // 处理时间字段
          if (obj.start_time && obj.start_time.value > 0 && obj.end_time && obj.end_time.value > 0) {
            self.form.active_time = [
              obj.start_time.text,
              obj.end_time.text
            ];
          }

          if (obj.exchange_start_time > 0 && obj.exchange_end_time > 0) {
            // 需要将时间戳转换为字符串格式
            const formatTime = (timestamp) => {
              if (!timestamp) return '';
              const date = new Date(timestamp * 1000);
              return date.getFullYear() + '-' +
                     String(date.getMonth() + 1).padStart(2, '0') + '-' +
                     String(date.getDate()).padStart(2, '0') + ' ' +
                     String(date.getHours()).padStart(2, '0') + ':' +
                     String(date.getMinutes()).padStart(2, '0');
            };

            self.form.exchange_time = [
              formatTime(obj.exchange_start_time),
              formatTime(obj.exchange_end_time)
            ];
          }

          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
          console.error('获取优惠券详情失败：', error);
          self.$message.error('获取优惠券详情失败');
        });
    },

    /*打开选择商家弹窗*/
    openMerchantDialog() {
      // 如果已经选择了商家，提示需要先删除
      if (this.form.merchants.length > 0) {
        this.$confirm('当前已有关联商家，如需更换请先删除当前商家', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteMerchantClick(0);
          this.open_merchant = true;
        });
      } else {
        this.open_merchant = true;
      }
    },

    /*关闭选择商家弹窗*/
    closeMerchantDialogFunc(e) {
      if (e.type != 'error') {
        // 将选择的用户添加到商家列表（只取第一个）
        let selectedUsers = e.params;
        if (selectedUsers && selectedUsers.length > 0) {
          let user = selectedUsers[0];

          console.log('选择的商家用户：', user);

          // 清空原有的商家列表，只保留一个
          this.form.merchants = [{
            user_id: user.user_id,
            nickName: user.nickName,
            avatarUrl: user.avatarUrl,
            mobile: user.mobile || '',
            role: user.role || 'supply'
          }];

          // 设置user_id，准备提交
          this.form.user_id = user.user_id;

          this.$message.success('已选择商家：' + user.nickName);
        }
      }
      this.open_merchant = false;
    },

    /*删除商家*/
    deleteMerchantClick(index) {
      this.form.merchants.splice(index, 1);
      // 清空user_id
      this.form.user_id = 0;
      this.$message.success('已删除关联商家');
    },

    /*提交修改*/
    onSubmit() {
      let self = this;
      let form = self.form;

      // 准备提交数据
      if (Number(form.coupon_type) === 30) {
        // 如果是提货卡类型，可能需要特殊处理
        form.product_list = self.tableFormat(self.form.products || []);
      }

      // 转换时间格式
      if (Number(form.expire_type) === 20 && form.active_time) {
        form.start_time = form.active_time[0] ? form.active_time[0] + ' 00:00:00' : '';
        form.end_time = form.active_time[1] ? form.active_time[1] + ' 23:59:59' : '';
      }

      if (Number(form.exchange_type) === 10 && form.exchange_time) {
        form.exchange_start_time = form.exchange_time[0] || '';
        form.exchange_end_time = form.exchange_time[1] || '';
      }

      // 设置商家ID（user_id字段）
      // 已经在closeMerchantDialogFunc中设置

      // 删除不需要的字段
      delete form.active_time;
      delete form.exchange_time;
      delete form.merchants;
      delete form.products; // 如果不需要products字段，可以删除

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          console.log('提交的数据：', JSON.stringify(form, null, 2));

          // 调试：显示user_id是否设置
          console.log('user_id值：', form.user_id);
          console.log('user_id类型：', typeof form.user_id);

          CouponApi.editCoupon(form, true)
            .then(data => {
              self.loading = false;
              if (data.code === 1) {
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                self.$router.push('/plus/coupon/index');
              } else {
                self.$message.error(data.msg || '修改失败');
              }
            })
            .catch(error => {
              self.loading = false;
              console.error('提交失败：', error);
              self.$message.error('提交失败，请重试');
            });
        } else {
          self.loading = false;
          self.$message.warning('请完善表单信息');
        }
      });
    },

    /*表格数据格式化（保留原有的格式化方法）*/
    tableFormat(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          assemble_stock: item.assemble_stock,
          assemble_price: item.assemble_price,
          product_attr: item.spec_name,
          assemble_product_sku_id:item.assemble_product_sku_id,
          product_price:item.product_price,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      if (curItem && curItem.spec_list) {
        curItem.spec_list = spec_list
      }
      curItem && newList.push(curItem);
      return newList;
    },

    /*取消*/
    cancelFunc(){
      this.$router.push({
        path:'/plus/coupon/index',
      });
    },

    // 上传背景图
    returnBgImgFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true;
              return false
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        if(this.bg_type=='bg'){
          this.form.bgImage = e[0]
          this.form.bg_image = e[0].file_id
        }else{
          if(this.bg_type=='exchange_bg'){
            this.form.exchange_bg = e[0].file_path
          }else{
            this.form.shareImage = e[0]
            this.form.share_image = e[0].file_id
          }
        }
      }
      this.isBgUpload = false
    },

    bgUpload(bg_type) {
      this.bg_type = bg_type;
      this.isBgUpload = true
    },

    deleteBgImg(bg_type) {
      if(bg_type=='bg'){
        this.form.bg_image = 0
        this.form.bgImage = null
      }else{
        if(this.bg_type=='exchange_bg'){
          this.form.exchange_bg = ''
        }else{
          this.form.share_image = 0
          this.form.shareImage = null
        }
      }
    },

    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.content = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
  font-size: 12px;
  margin-top: 5px;
}
.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;
  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}
.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;
  img {
    width: 110px;
    //height: 110px;
  }
}
.image-box:hover .delete-btn {
  display: block;
}
.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}
.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

/*商家头像样式*/
.merchant-info .pic {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}
.merchant-info img {
  border-radius: 50%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/edit.vue